import { useEffect } from "react";

const SITE = "https://vooglyai.com";

// react-helmet-async React 19 par meta/link tags inject nahi kar pata —
// isliye seedha DOM upsert: index.html ke static tags ko hi update karta hai, duplicates kabhi nahi bante.
function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function Seo({ title, description, path = "/", image = "/og-image.png", noindex = false, jsonLd = null }) {
  useEffect(() => {
    const img = image.startsWith("http") ? image : `${SITE}${image}`;
    document.title = title;
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1");
    setLink("canonical", `${SITE}${path}`);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", `${SITE}${path}`);
    setMeta("property", "og:image", img);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", img);
    // structured data (FAQPage, Product, Article) — single upserted script tag per type
    if (jsonLd) {
      let el = document.head.querySelector('script[type="application/ld+json"][data-seo="route"]');
      if (!el) {
        el = document.createElement("script");
        el.type = "application/ld+json";
        el.setAttribute("data-seo", "route");
        document.head.appendChild(el);
      }
      el.textContent = JSON.stringify(jsonLd);
    }
  }, [title, description, path, image, noindex, JSON.stringify(jsonLd)]);
  return null;
}
